import { useEffect, useRef, useState } from 'react';

export interface CountdownTimerProps {
  expiresAt: Date;
  onExpired: () => void;
  variant?: 'large' | 'inline';
}

function formatMmSs(totalSeconds: number): string {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export default function CountdownTimer({ expiresAt, onExpired, variant = 'large' }: CountdownTimerProps) {
  const fired = useRef(false);
  const [remainingSec, setRemainingSec] = useState(() => {
    const diff = Math.floor((expiresAt.getTime() - Date.now()) / 1000);
    return Math.max(0, diff);
  });

  useEffect(() => {
    fired.current = false;
    const tick = () => {
      const diff = Math.floor((expiresAt.getTime() - Date.now()) / 1000);
      const next = Math.max(0, diff);
      setRemainingSec(next);
      if (next === 0 && !fired.current) {
        fired.current = true;
        onExpired();
      }
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [expiresAt, onExpired]);

  const urgent = remainingSec > 0 && remainingSec < 120;

  if (variant === 'inline') {
    return (
      <span style={{ color: urgent ? 'var(--ps-error)' : 'inherit', fontVariantNumeric: 'tabular-nums' }}>
        {formatMmSs(remainingSec)}
      </span>
    );
  }

  return <p className={`ps-time${urgent ? ' urgent' : ''}`}>{formatMmSs(remainingSec)}</p>;
}
